var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.isShow)?_c('img',{staticClass:"wimg",attrs:{"src":require("@/assets/img/down_wechat.jpg")}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }